<template>
    <div class="container">
        <div class="mt-2">
            <main-menu type="-1"></main-menu>
        </div>
      <!-- 如果没有blog -->
        <div v-if="$route.params.id==0">
            <regist-blog></regist-blog>
        </div>
        <div class="row" v-if="$route.params.id!=0">
<!--        <index-header v-if="userinfo.id>0" :info="userinfo" ref="header"></index-header>-->
        <div class="d-lg-none col text-right mb-3">

            <el-button 
            v-if="$store.state.user.userinfo.userID==$route.params.id" 
            round
            @click="$router.push('/blog/my/')">
                <i class="el-icon-notebook-2"></i> {{$t('message').userindex.menu_btn_manage}}
            </el-button>
        </div>
        <div class="col-lg-4 d-lg-block" v-show="bloggerID!=0">
          <right-footer></right-footer>
            <!-- <user-index-sort :data="sortList"></user-index-sort> -->
            <div class="collection-list m" v-if="collectionList.length>=0">
                <collection-list v-bind:data="collectionList" :userdata="false" :title="$t('message').userindex.menu_title" @showbubble="showbubble"></collection-list>
            </div>
            <template v-if="userinfo.bloggerinfo_bloggerID">
                <div
                v-if="userinfo.bloggerinfo_bloggerID.is_group"
                class="left-box mt-3 p-3">
                    <div class=" d-flex justify-content-between">
                        <h4>{{$t('message').userindex.left_title2}}</h4>
                        <el-button v-if="$store.state.user.userinfo.UserID==$route.params.id" type="text" link v-bind:style="{paddingRight:0 }" @click="openAddGroupMemberDialog()" slot="reference">
                            + {{$t('message').userindex.left_btn_add}}
                        </el-button>
                    </div>
                    <div class="member_list">
                        <div class="d-flex align-items-center py-2" v-for="item in this.groupMemberList" :key="item.id">
                            <el-avatar :src="item.userinfo_userID.avatar">{{item.userinfo_userID.first_letter}}</el-avatar>
                            <div class="name pl-2 flex-fill">{{ item.userinfo_userID.username }}</div>
                            <el-popconfirm v-if="$store.state.user.userinfo.UserID==$route.params.id"
                                @confirm="removeGroupMember(item.userID)"
                                confirm-button-text="移除作者"
                                :title="$t('message').userindex.group_blog_remove_member_alert"
                            >
                                <el-button slot="reference" type="text" style="color:grey">移除作者</el-button>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
            </template>
            <blog-help></blog-help>
        </div>
        <div class="col-lg-8 col-12 proheader" v-show="bloggerID!=0">
                  <index-header v-if="userinfo.id>0" :info="userinfo" ref="header"></index-header>
          <div class="profile-header mt-2 mb-3 border-bottom">
                <ul class="nav justify-content-center">
                    <li class="col nav-item text-center px-0" v-for="(item,index) in this.tabs" :key="index">
                        <a 
                        class="nav-link" 
                        :class="{active:currentTabId==item.id}" 
                        href="#"
                        @click="changeTab(item.id)">{{item.text}}</a>
                    </li>
                </ul>
            </div>
            <div 
            v-infinite-scroll="loadArticle"
            infinite-scroll-disabled="disabled"
            infinite-scroll-distance="50">
                <article-list-item 
                v-for="item in articlelists"
                v-bind:key="item.articleID"
                v-bind:data="item"
                type="0">
                </article-list-item>
            </div>
            <div class="text-center py-5" v-if="loading.article"><!-- loader -->
                <i class="now-ui-icons loader_refresh spin"></i>
            </div>
            <p class="text-center py-4" v-if="noMore">没有更多了</p>
        </div>

      </div>
      <el-dialog
        :title="$t('message').userindex.group_blog_add_member"
        :visible.sync="addGroupMemberDialog"
        width="33%">
        <div slot class="pl-3">
            <el-autocomplete
            popper-class="invate-autocomplete"
            v-model="invateUser"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            :placeholder="$t('message').userindex.group_blog_add_pleacholder"
            @select="handleSelect">
                <i
                    class="el-icon-search el-input__icon"
                    slot="prefix">
                </i>
                <template slot-scope="{ item }">
                    <div class="d-flex py-2">
                        <el-avatar :src="item.userinfo_id.avatar">{{item.userinfo_id.first_letter}}</el-avatar>
                        <div class="pl-2">
                            <div class="name">{{ item.userinfo_id.username }}</div>
                            <span class="addr">{{ item.userinfo_id.email }}</span>
                        </div>
                    </div>
                </template>
                <el-button slot="append" type="primary" :disabled="invateUserID===0" @click="addGroupMember">添加作者</el-button>
            </el-autocomplete>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" :disabled="invateUserID===0" @click="dialogVisible = false">添加作者</el-button> -->
        </span>
        </el-dialog>
    </div>
</template>
<script>
import BlogHelp from '../pages/components/Main/BlogHelp.vue';
import MainMenu from '../pages/components/Main/MainMenu.vue';
import ArticleListItem from '../pages/components/Main/ArticleListItem.vue';
import UserIndexSort from '../pages/components/Main/UserIndexSort.vue';
import CollectionList from '../pages/components/Main/CollectionList.vue';
import IndexHeader from './IndexHeader';
import RegistBlog from '../../user/login/RegistBlog';
import RightFooter from '@/layout/RightFooter.vue'

import blog from '../blog.service';

export default {
  name: 'blog-user-index',
  components: {
    MainMenu,
    ArticleListItem,
    CollectionList,
    IndexHeader,
    RegistBlog,
    BlogHelp,
    RightFooter
  },
  watch:{
    "$route.params.id":function(val){
        this.userID = val;
        this.init_data();
    }
  },
  created () {
    // this.loadArticle();
    this.init_data();
  },
  computed:{
    disabled () {
      return this.bloggerID==0 || this.noMore || this.loading.article
    }
  },
  methods:{
    init_data(){
        blog.get_user_info(this.$route.params.id).then(res=>{
            this.userinfo = res.data;
            this.bloggerID = res.data.bloggerID?res.data.bloggerID:0;
            blog.get_blogger_info(this.bloggerID).then(res=>{
                if(!res.status){
                    this.bloggerID = 0;
                    this.$message.error(res.error);
                    this.is_blocked_user(res);
                }
                this.articlelists = [];
                this.collectionList = [];
                if(this.bloggerID!=0){
                    this.loadArticle();
                    blog.category_list(this.bloggerID).then(res=>{
                        if(res.status){
                            this.collectionList=res.data;
                        }else{
                            this.$message.error(res.error);
                        }
                    })
                } 
            });
            if(this.userinfo.bloggerinfo_bloggerID.is_group){
                this.get_group_member();
            }
        });
        this.user_login_wxc_to_haiwai(this.token);
    },
    changeTab(id){
        this.currentTabId = id;
        this.lastID.article = 0;
        this.articlelists = [];
        this.loadArticle();
    },
    loadArticle(){
        this.loading.article = true
        if(this.currentTabId==0){
            blog.article_list_recent(this.bloggerID,this.lastID.article).then(res=>{
                this.getList(res);
            });
        };
        if(this.currentTabId==1){
            blog.article_list_hot(this.bloggerID,this.lastID.article).then(res=>{
                this.getList(res);
            });
        };
        if(this.currentTabId==2){
            blog.article_list_comment(this.bloggerID,this.lastID.article).then(res=>{
                this.getList(res);
            });
        };
    },
    getList(res){
        if(res.status){
            let arr = res.data;
            this.noMore = arr.length<30 ? true : false;
            this.lastID.article = arr.length<30 ? this.lastID.article : arr[arr.length-1].create_date ;
            this.articlelists = this.articlelists.concat(arr) ;
            this.loading.article=false;
        }
    },
    user_login_wxc_to_haiwai(token){
        let user =this.$store.state.user;
        if(this.token && !user.userinfo.id){
        user.user_login_wxc_to_haiwai(token).then(res=>{
            user.getUserInfo(this.$route.params.id).then(res=>{
                this.$router.push('/blog/user/'+this.$route.params.id)
            })
        })
        }else{
            this.$router.push('/blog/user/'+this.$route.params.id)
        }
    },
    showbubble(){
        this.$refs['header'].showBubble()
    },
    is_blocked_user(res){
        this.userinfo.bloggerinfo_bloggerID.name = res.error;
        this.userinfo.bloggerinfo_bloggerID.description = "";
        setTimeout(()=>{
            this.$router.push('/blog/')
        },30000)
    },
    openAddGroupMemberDialog(){
        this.addGroupMemberDialog = true;
        this.invateUser = '';
        this.invateUserID = 0 ;
    },
    querySearch(queryString, cb) {
        if(queryString!==''){
            this.invateUserID = 0 ;
            this.$store.state.user.public_search_user(queryString).then(res=>{
                if(res.status){
                    // 调用 callback 返回建议列表的数据
                    cb(res.data);
                }
            })
        }
    },
    handleSelect(item) {
        this.invateUser = item.userinfo_id.username;
        this.invateUserID = item.id;
    },
    addGroupMember(){
        if(this.invateUserID){
            this.$store.state.user.group_member_add(this.invateUserID).then(res=>{
                this.$message.success("成功添加作者！");
                this.sendQqh(this.invateUserID,`我已将你添加为 ${this.userinfo.bloggerinfo_bloggerID.name} 的作者，今后你在发博文时可以选择将文章发到 ${this.userinfo.bloggerinfo_bloggerID.name}。`);
                this.invateUser = '';
                this.invateUserID = 0;
                this.get_group_member();
            })
        }
    },
    removeGroupMember(userID){
        this.$store.state.user.group_member_delete(userID).then(res=>{
            this.$message.success("成功移除作者！");
            this.sendQqh(userID,`你已被移出 ${this.userinfo.bloggerinfo_bloggerID.name} 的成员名单`);
            this.get_group_member();
        }).catch(err=>{
            console.log(err.error)
        })
    },
    sendQqh(touserID,msg){
        this.$store.state.user.sendQqh(touserID,msg).then(res=>{
            
        }).catch(err=>{console.log(err.error)})
    },
    get_group_member(){
        this.$store.state.user.get_group_member(this.userID).then(res=>{
            this.groupMemberList = res.status?res.data:[]
        }).catch(err=>{
            console.log(err.error)
        })
    }
  },
  data() {
    return {
        userID:this.$route.params.id,
        bloggerID:0,
        userinfo:{},
        token:this.$route.query.token,
        currentTabId:0,
        noMore:false,
        lastID:{article:0,wenji:0},
        loading:{article:true,wenji:true},
        tabs:[
            {
                id:0,
                text:this.$t('message').userindex.article_tab0,
            },{
                id:1,
                text:this.$t('message').userindex.article_tab1,
            },{
                id:2,
                text:this.$t('message').userindex.article_tab2,
            }
        ],
        authorInfo : {},
        articlelists: [],
        collectionList : [],
        invateUser:'',
        invateUserID:0,
        addGroupMemberDialog:false,
        groupMemberList:[]
    };
  },
};
</script>
<style>
.profile-header .nav-link{
  color:#657786
}
.profile-header .nav-link.active {
  color: #1D1D1D;
  border-bottom: 2px solid #39B8EB;
  font-weight: 600;
}
@media (max-width: 992px){
  .collection-list.m{
    max-height: 114px;
    overflow: hidden;
  }
  .proheader{
    border-top: 10px solid #ffffff;
  }
}
@media (max-width: 767.98px){
  .collection-list.m{
    max-height: 114px;
    overflow: hidden;
  }
  .proheader{
    border-top: 10px solid #ffffff;
  }
}
@media (max-width: 575.98px)  {
  .collection-list.m{
    max-height: 114px;
    overflow: hidden;
  }
  .proheader{
    border-top: 10px solid #ffffff;
  }
}
</style>
